/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from 'react';
import { DataRowRecord, SelectSingleRowAction, DataRowState } from '../types';
import BaseCheckbox from './BaseCheckbox';

type DataCellCheckboxProps<T> = {
  keyField: string;
  row: T;
  rowCount: number;
  selectedCount: number;
  singleSelect: boolean;
  selected: boolean;
  selectableRowDisabled: DataRowState<T>;
  onSelected: (action: SelectSingleRowAction<T>) => void;
};

function DataCellCheckbox<T extends DataRowRecord>({
  keyField,
  row,
  selected,
  selectedCount,
  singleSelect,
  rowCount,
  selectableRowDisabled,
  onSelected,
}: DataCellCheckboxProps<T>): JSX.Element {
  const disabled = !!(selectableRowDisabled && selectableRowDisabled(row));

  const handleOnSelected = () => {
    if (singleSelect && selectedCount >= 1 && !selected) return;
    onSelected({
      type: 'SELECT_SINGLE_ROW',
      row,
      isSelected: selected,
      keyField,
      rowCount,
    });
  };

  return (
    <div
      className='relative flex items-center box-border leading-normal justify-center select-none whitespace-nowrap'
      style={{ flex: '0 0 48px', minWidth: '48px' }}
    >
      <BaseCheckbox
        name={`selected-${row[keyField]}`}
        checked={selected}
        disabled={disabled}
        onClick={handleOnSelected}
      />
    </div>
  );
}

export default DataCellCheckbox;
